import { useCallback } from 'react';
import type { OnboardingPreferencesInput } from '@tabbio/types';
import { useSaveOnboardingPreferences } from './useOnboardingApi';
import {
  captureProductException,
  getErrorObservabilityProperties,
  trackProductEvent,
} from '../lib/product-analytics';

type PersistContext = {
  step: string;
};

export function usePersistOnboardingPreferences(context: PersistContext) {
  const mutation = useSaveOnboardingPreferences();

  const persistOnboardingPreferences = useCallback(
    async (input: OnboardingPreferencesInput) => {
      try {
        await mutation.mutateAsync(input);
        trackProductEvent('onboarding_preferences_saved', {
          step: context.step,
          keys: Object.keys(input).sort(),
        });
        return true;
      } catch (error) {
        trackProductEvent('onboarding_preferences_save_failed', {
          step: context.step,
          keys: Object.keys(input).sort(),
          ...getErrorObservabilityProperties(error),
        });
        captureProductException(error, {
          feature: 'onboarding',
          action: 'save_preferences',
          step: context.step,
        });
        return false;
      }
    },
    [context.step, mutation],
  );

  return {
    isPersistingPreferences: mutation.isPending,
    persistOnboardingPreferences,
  };
}
